module.exports = __webpack_public_path__ + "img/msg-icon.f293c1de.svg";